import { DialogTitle } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { ModalHeaderProps } from './types';

export function ModalHeader(props: ModalHeaderProps) {
  const { className, as = 'div', ...other } = props;
  const { modal } = useTheme();

  const cls = twMerge(modal.header, className);

  return <DialogTitle as={as} className={cls} {...other} />;
}
